import { ActivityStatusDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { ActivityStatus } from '@/services/graphql/types';

export const mapperToActivityStatus = createEnumMapperFunction(
  ActivityStatusDataEnum,
  ActivityStatus
);
